module.exports = {
	"articleTitle1": "On the Daily: Dean Aaron Dworkin steps down from School of Music ...",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "School of Music, Theatre & Dance",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/department-musical-theater-chair-departs-1",
	"articleSnippet1": "Apr 5, 2017 ... School of Music, Theatre & Dance Dean Aaron Dworkin announced Wednesday \nafternoon he will be stepping down from his position effective ...",
	"articleSnippet2": "Jun 4, 2016 ... Brent Wagner, chair of the Department of Musical Theatre at the University of \nMichigan, and the only chair in the department's history, retired ...",
	"totalMisc": 0,
	"articleTitle2": "Department of Musical Theatre chair departs ",
	"address": "1100 Baits Dr. Ann Arbor, MI",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/151009/del.NEW_.StarkidReunion.10.08.15306.jpg?itok=oPDQV65C",
			"author": "Delaney Ryan",
			"caption": "Alums Joey Richter, Darren Criss, and Lauren Lopez perform at \"A Very Starkid Reunion\" in honor of the 100th anniversary of the School of Music, Theatre & Dance at the Power Center on Thursday."
		}
	],
	"position": {
		"lat": 42.290412,
		"lng": -83.72102
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/musicschool.json
// module id = 928
// module chunks = 0